module.exports = __webpack_public_path__ + "static/img/run2023 original.cd527770.jpg";